"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarMotion = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("@completeanatomy/config");
const PanelItem_1 = __importDefault(require("../../atoms/PanelItem"));
const ScrollContainer_1 = __importDefault(require("../../atoms/ScrollContainer"));
const react_1 = require("react");
const OtherMuscles_1 = require("../OtherMuscles");
const SidebarTabs_1 = require("../SidebarTabs");
function SidebarMotion({ parts, onClick, selectedPart, tabName, }) {
    const tabs = {
        TabName: tabName,
        OtherMusclesTab: 'Other Muscles',
    };
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(tabs.TabName);
    const config = (0, config_1.useConfigService)();
    const onTabClick = (tab) => {
        setSelectedTab(tab);
    };
    const imageBaseUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SidebarTabs_1.SidebarTabs, { selectedTab: selectedTab, tabs: tabs, onTabClick: onTabClick, "data-e2e": 'SidebarMotion_SidebarTabs' }), selectedTab === tabs.TabName ? ((0, jsx_runtime_1.jsx)(ScrollContainer_1.default, { "data-e2e": 'SidebarMotion_ScrollContainer', children: parts.map(part => ((0, jsx_runtime_1.jsx)(PanelItem_1.default, { onClick: () => onClick(part), isSelected: (selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.identifier) === part.identifier, image: imageBaseUrl + part.img, text: part.title, "data-e2e": 'SidebarMotion_PanelItem' }, part.identifier))) })) : ((0, jsx_runtime_1.jsx)(OtherMuscles_1.OtherMuscles, { "data-e2e": 'SidebarMotion_OtherMuscles' }))] }));
}
exports.SidebarMotion = SidebarMotion;
